module.exports = __webpack_public_path__ + "static/media/icon_mask.71bfa3b7.png";